import { gql } from 'apollo-boost';

export const newQuicksightDashboard = gql`
mutation newQuicksightDashboard (
  $name: String,
  $information: String
  $awsId: String,
  $accountList: String,
) {
newQuicksightDashboard (
  name: $name,
  information: $information
  awsId: $awsId,
  accountList: $accountList
) {
    success
    id
  }
}
`;
